import React, { useRef } from 'react';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { Environment, MeshDistortMaterial, Float } from '@react-three/drei';
import * as THREE from 'three';

const AntigravitySphere = () => {
    const sphereRef = useRef();
    const { viewport, mouse } = useThree();

    useFrame((state, delta) => {
        // Smoothly rotate the sphere towards the cursor
        const targetRotationY = (mouse.x * Math.PI) / 6;
        const targetRotationX = (-mouse.y * Math.PI) / 6;

        sphereRef.current.rotation.y = THREE.MathUtils.lerp(sphereRef.current.rotation.y, targetRotationY, 0.05);
        sphereRef.current.rotation.x = THREE.MathUtils.lerp(sphereRef.current.rotation.x, targetRotationX, 0.05);
        sphereRef.current.rotation.z += 0.1 * delta; // Constant spin

        // Subtle positional shift towards the cursor
        const targetPosX = mouse.x * 0.4;
        const targetPosY = mouse.y * 0.4;
        
        sphereRef.current.position.x = THREE.MathUtils.lerp(sphereRef.current.position.x, targetPosX, 0.05);
        sphereRef.current.position.y = THREE.MathUtils.lerp(sphereRef.current.position.y, targetPosY, 0.05);
    });

    return (
        <Float speed={2} rotationIntensity={1} floatIntensity={2}>
            <group ref={sphereRef} scale={viewport.width / 5}>
                {/* Core Sphere */}
                <mesh>
                    <sphereGeometry args={[1, 64, 64]} />
                    <MeshDistortMaterial
                        color="#4c1d95"
                        envMapIntensity={2.5}
                        clearcoat={0.8}
                        clearcoatRoughness={0.1}
                        metalness={0.9}
                        roughness={0.1}
                        distort={0.4}
                        speed={2}
                    />
                </mesh>
                {/* Wireframe Aura */}
                <mesh scale={1.05}>
                    <sphereGeometry args={[1, 32, 32]} />
                    <MeshDistortMaterial
                        color="#c4b5fd"
                        wireframe
                        distort={0.4}
                        speed={2}
                        transparent
                        opacity={0.3}
                    />
                </mesh>
            </group>
        </Float>
    );
};

const Scene3D = () => {
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, pointerEvents: 'none', background: '#020204' }}>
            <Canvas camera={{ position: [0, 0, 8], fov: 45 }} dpr={[1, 2]}>
                <color attach="background" args={['#020204']} />
                
                <ambientLight intensity={0.1} />
                <directionalLight position={[10, 20, 10]} intensity={2} color="#c4b5fd" />
                <directionalLight position={[-10, -10, -10]} intensity={1} color="#4c1d95" />
                <pointLight position={[0, 0, 5]} intensity={1.5} color="#8b5cf6" distance={20} />
                
                <AntigravitySphere />
                
                <Environment preset="night" />
            </Canvas>
        </div>
    );
};

export default Scene3D;
